const basicColors = {
  black: '#1A1A1A',
  grayLight: '#F6F8FA',
  grayDark: '#BABDC3',
  gray: '#CBCFD3',
  white: '#FFFFFF',
  green: '#35C25C',
  blue: '#2D99FF',
  red: '#EB3B3B',
  orange: '#FD8357',
}
const indicatorColors = {
  theme: '#DB2231',
  success: basicColors.green,
  error: basicColors.red,
  warn: basicColors.orange,
  fail: '#EAEEF2',
  disabled: '#B1B1B1',
  wechat: '#3FA72E',
}
const elementColors = {
  text: basicColors.black,
  textLight: '#3A404A',
  textTip: '#8D8D8D',
  link: indicatorColors.theme,
  line: 'rgba(0,0,0,0.12)',
  lineLight: 'rgba(0,0,0,0.06)',
}
const colors = {
  ...basicColors,
  ...indicatorColors,
  ...elementColors,
}

const animations = {
  speed: {
    veryFast: '0.1s',
    fast: '0.2s',
    normal: '0.5s',
    slow: '1s',
    verySlow: '2s',
  },
}
const shadows = {
  outline: '0 0.125rem 0.5rem rgba(0,0,0,0.15)',
  outlineLight: '0 0.125rem 0.5rem rgba(0,0,0,0.1)',
}
export const MARKETUP = {
  colors,
  animations,
  shadows
}
